import _ from 'lodash';
import { DrugAPI } from '../controllers/api';

class Product {
    _api;
    //list;
    //query;

    constructor(){
        this._api = new DrugAPI();

        //this.getProducts = this.getProducts.bind(this);
        this.queryProducts = this.queryProducts.bind(this);
        this.getProduct = this.getProduct.bind(this);
    }

    // getProducts(){
    //     return this._api.execute('GetProducts')
    //         .then(callback.bind(this))
    //         .catch(fallback.bind(this));
    //
    //     ///------------
    //
    //     function callback(output){
    //         //TODO: Add logic to process predefined output JSON format
    //         //console.log(output);
    //
    //         return Promise.resolve( output );
    //     }
    //     function fallback(error){
    //         return Promise.reject(error);
    //     }
    // }

    queryProducts(query){
        return this._api.execute('QueryProducts',[],query)
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            //TODO: Add logic to process predefined output JSON format
            //console.log(output);

            return Promise.resolve( output );
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }

    getProduct(id){
        return this._api.execute('GetProductById',[ id ])
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            //TODO: Add logic to process predefined output JSON format
            //console.log(output);

            return Promise.resolve( output );
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }


}


export default Product;